module.exports = __webpack_public_path__ + "static/20-thumb-aeb6bfbdaf63f4b9258822d6a5e6178c.jpg";